module.exports = __webpack_public_path__ + "img/linkus-tg.94869ae1.png";